module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    on: {
      "click": _vm.clickHandler
    }
  }, [(_vm.prefixIcon) ? _c('rt-icon', {
    staticClass: "rt-detail-button-prefix-icon",
    attrs: {
      "name": _vm.prefixIcon
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.suffixIcon) ? _c('rt-icon', {
    staticClass: "rt-detail-button-suffix-icon",
    attrs: {
      "name": _vm.suffixIcon
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59108a14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/detail/rtDetailButton.vue
// module id = 1507
// module chunks = 91